import { useLazyGetCommonConfigDataQuery } from "@assessment/store/slices/api/assessmentApiSlice";
import { useAppSelector } from "@assessment/store/store";
import { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { useTranslation } from "react-i18next";
import "react-circular-progressbar/dist/styles.css";
import { useParams } from "react-router-dom";

const ShowResultOnSubmit = ({
  data,
  showPercentage,
  showScore,
  orgBasedFeatureName,
  isCertificate
}: any) => {
  const { t } = useTranslation();
  const percentage = (data?.obtainedMarks / data?.totalMarks) * 100;
  const passPercentage = Number(localStorage.getItem("passPercentage"));

  const pathColor =
    percentage < passPercentage ? "rgb(251, 191, 36)" : "rgb(0, 135, 93)";

  return (
    <div
      className={`w-full rounded-xl shadow-sm scale-110 pb-2 ${
        showPercentage && percentage < passPercentage
          ? "bg-amber-50"
          : "bg-[#F0FDF4]"
      }`}
    >
      <div
        className={`flex ${
          showPercentage ? "sm:flex-row" : "flex-col"
        }  rounded-2xl p-6 w-full md:max-w-2xl`}
      >
        {/* Left Column - Text Info */}
        <div
          className={`${
            showPercentage ? "sm:w-2/3 w-full" : "w-full"
          } flex flex-col justify-start px-4 ${
            !showPercentage ? "items-center text-center" : ""
          } mb-4 sm:mb-0`}
        >
          <p className="text-base font-semibold uppercase mb-4 w-fit text-gray-500">
            {t("assessment.resultCard.title", {
              featureName: orgBasedFeatureName
            })}
          </p>
          {showScore && (
            <div
              className={`mb-4 w-fit font-semibold text-2xl ${percentage < passPercentage ? "text-[#FFB60C]" : "text-[#00875D]"}`}
            >
              <span>{t("assessment.resultCard.score")}: </span>
              {data?.obtainedMarks}/{data?.totalMarks}
            </div>
          )}
          {isCertificate && showPercentage && (
            <div className="font-medium text-xl text-gray-500 mb-2 w-fit">
              {t("assessment.resultCard.passPercentage")}: {passPercentage}%
            </div>
          )}
        </div>

        {/* Right Column - CircularProgressbar */}
        {showPercentage && (
          <div className="sm:w-1/3 w-full flex items-center justify-center px-4">
            <div className="size-28">
              <CircularProgressbar
                value={percentage}
                text={`${Math.round(percentage)}%`}
                styles={{
                  ...buildStyles({
                    rotation: 0,
                    strokeLinecap: "round",
                    pathTransitionDuration: 0.5,
                    pathColor: pathColor,
                    trailColor: "rgb(226, 232, 240)"
                  }),
                  text: {
                    fontWeight: 700,
                    fontSize: "18px",
                    fill:
                      percentage < passPercentage
                        ? "rgb(251, 191, 36)"
                        : "rgb(0, 135, 93)"
                  }
                }}
              />
            </div>
          </div>
        )}
      </div>
      {isCertificate && (
        <div className={`rounded-md px-1 mx-6 mt-2 mb-6 py-1.5 bg-white`}>
          {percentage < passPercentage ? (
            <p className="text-sm font-normal text-[#C38D00]">
              {t("assessment.resultCard.marksAway", {
                count: data?.totalMarks - data?.obtainedMarks
              })}
            </p>
          ) : (
            <p className="text-sm italic font-normal text-[#00875D]">
              {t("assessment.resultCard.certificationEarned")}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default ShowResultOnSubmit;
